// In production, we register a service worker to serve assets from local cache.
// The SW uses a network-first strategy so updates are always loaded immediately.

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export default function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = new URL('/service-worker.js', window.location.origin).toString();

      if (isLocalhost) {
        checkValidServiceWorker(swUrl);
        navigator.serviceWorker.ready.then(() => {
          console.log('[SW] Service worker active.');
        });
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      // When the SW finds an update, activate it immediately and reload.
      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Tell the new SW to skip waiting and take over right now.
              installingWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          }
          if (installingWorker.state === 'activated') {
            // New SW is now controlling the page — reload to load fresh assets.
            window.location.reload();
          }
        });
      });

      // Also handle the case where another tab triggered a SW update.
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    })
    .catch(error => {
      console.error('[SW] Registration error:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl)
    .then(response => {
      const contentType = response.headers.get('content-type') || '';
      if (!response.ok || !/javascript|ecmascript/i.test(contentType)) {
        console.warn(`[SW] Not registered: ${swUrl} → ${response.status}`);
        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration) registration.unregister();
        });
        return;
      }
      registerValidSW(swUrl);
    })
    .catch(error => {
      console.warn('[SW] Check failed; continuing without it.', error);
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
